import { REQUEST } from 'Stores'
import { GET_ACCOUNT_INFO, UPDATE_ACCOUNT_INFO_BASIC, UPDATE_ACCOUNT_INFO_BUSINESS } from './constants'

export function getAccountInfo(payload) {
  return {
    type: REQUEST(GET_ACCOUNT_INFO),
    payload
  }
}

export function updateAccountInfoBasic(payload) {
  return {
    type: REQUEST(UPDATE_ACCOUNT_INFO_BASIC),
    payload
  }
}
export function updateAccountInfoBusiness(payload) {
  return {
    type: REQUEST(UPDATE_ACCOUNT_INFO_BUSINESS),
    payload
  }
}
